<div *transloco="let t" class="flex flex-1 flex-col">
  <pxc-share (cancelAction)="close()" (confirm)="confirm($event)">
    <pxc-sequence-preview [isPatientClickable]="false" [sequence]="sequence" [showActions]="false" />
  </pxc-share>

  <ng-template [(tuiNotificationMiddle)]="isLoading">
    <tui-loader tuiAnimated />
    <div class="text-center" tuiAnimated>{{ t('Partage de votre séquence en cours ...') }}</div>
  </ng-template>
</div>
